import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "host",
  "use": "host-usage",
  "viewBox": "0 0 18 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 12\" id=\"host\"><g fill-rule=\"nonzero\"><path d=\"M11.34 0H.66A.67.67 0 000 .66v7.68A.67.67 0 00.66 9H4v2H2v1h8v-1H8V9h3.34a.67.67 0 00.66-.66V.66a.67.67 0 00-.66-.66zM11 7.47a.53.53 0 01-.53.53H1.53A.53.53 0 011 7.47V1.53A.53.53 0 011.53 1h8.94a.53.53 0 01.53.53v5.94zM13 0v12h5V0h-5zm4 2h-3V1h3v1z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id